import {
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input, OnChanges,
  OnInit,
  Output, SimpleChanges,
} from '@angular/core';
import {Config, FieldDefine, FormDefine, ServiceCode} from '../../../core';
import {Util} from '../../../core';
import {FieldType} from '../../../core';
import {ApiService} from '../../../core';
import {StateService} from '../../../core';
import {LanguagesService} from '../../../core';
import { checkIcon } from '@progress/kendo-svg-icons';
import {MultiSelectComponent} from '../multi-select/multi-select.component';

@Component({
  selector: 'gc-field',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.less']
})

export class FieldComponent implements OnInit, OnChanges {

  public icons = { checkIcon };

  dateFormat = { Date: Config.dateFormat, DateTime: Config.dateTimeFormat };

  TypeEnum = FieldType;
  lang = LanguagesService;

  autocompleteOptions = [];
  // listOptions: {[key: string]: any}[] = [];
  data = [];
  autocompleteData = [];
  optionsKey = null;

  constructor(protected componentFactoryResolver: ComponentFactoryResolver, private api: ApiService, private state: StateService) { }

  @Input() form: FormDefine;
  @Input() define: FieldDefine;
  private recordVar: any;
  @Input()
  get record(): any {
    return this.recordVar;
  }
  set record(v) {
    this.recordVar = v;
    // this.loadImage();
  }

  private apiUrlVar: string;
  @Input()
  get apiUrl(): string {
    return this.apiUrlVar;
  }
  set apiUrl(v) {
    this.apiUrlVar = v;
    // this.loadImage();
  }


  @Input() editable: boolean;
  @Input() link: (record: any) => any;
  @Input() thumbnail = 1;

  @Output()
  changed: EventEmitter<{[key: string]: any}> = new EventEmitter();

  @Output()
  detailMultiSelect: EventEmitter<MultiSelectComponent> = new EventEmitter();

  isLoading = false;
  image = null;

  // list: {[key: string]: any[]};
  private fieldValue: any;
  @Input()
  get value(): any {
    return this.fieldValue;
  }
  set value(val) {
    this.fieldValue = val;
    this.valueChange.emit(this.fieldValue);
    this.init();
  }
  @Output() valueChange = new EventEmitter();

  init(): void {
    if (this.form && this.define && this.define.listName && !this.define.autocomplete) {
      if (!this.form.optionsMap){
        this.form.optionsMap = {};
      }
      this.optionsKey = this.getListOptionsKey(this.define);
      if (this.define.choices || this.define.tree ) {
        // Nếu là choices hoac tree thì lấy hết data trước luôn cho khỏe
        // Nhưng níu có param thì phải load lại nhé
        if (this.form.optionsMap[this.optionsKey] && !this.define.listParam) {
          this.data = this.form.optionsMap[this.optionsKey].slice();
        }else{
          this.getListValues(this.define, null, null, result => {
            // Tree
            if (result) {
              if (this.define.tree) {
                this.form.optionsMap[this.optionsKey] = result;
              }else{
                this.form.optionsMap[this.optionsKey] = Util.toKendoListValues(result);
              }
              this.data = this.form.optionsMap[this.optionsKey].slice();
            }
          });
        }
      }else{
        // Nếu la list name thì cho em nó cái default trước
        const complexName = Util.complexFieldName(this.define.name);
        if (this.record[complexName]) {
          if (!this.form.optionsMap[this.define.listName]) {
            this.form.optionsMap[this.define.listName] = [];
          }
          this.data = [this.record[complexName]];
        }

        // Get from optionMap first.
        if (this.form.optionsMap[this.optionsKey] && this.form.optionsMap[this.optionsKey].length > 0){
          this.data = this.form.optionsMap[this.optionsKey].slice();
          return;
        }

      }
    }
  }
  ngOnInit(): void {

  }

  numberFormatter = (value: number) => {
    if (value === undefined || value === null) {
      return '';
    }

    if (!this.define || this.define.decimal === undefined || this.define.decimal === null ) {
      return  value;
    }

    return Util.numberFormat(value, this.define.decimal);

  }

  getNumberFormat(): string {
    if (this.define.decimal != null) {
      return 'n' + this.define.decimal;
    }else {
      return '#';
    }
  }

  // parserNumber = (value: string) => value.replace(',', '');

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.define || !this.define.image) {
      return;
    }

    if (!changes.value) {
      return;
    }
    // console.error('ngOnChanges');
    // console.log(changes);
    this.loadImage();
  }

  onChange(value: any, text = null): void {
    if (!this.form || !this.define) {
      return;
    }

    // Reset invalidate error
    if (this.form.invalidInfo[this.record.serial]
      && this.form.invalidInfo[this.record.serial][this.define.name]) {
      delete this.form.invalidInfo[this.record.serial][this.define.name];
    }

    // Link to list box
    if ((this.define.listName || this.define.listValues) && !this.define.autocomplete && !this.define.choices) {
      const fields = this.form.fields;
      fields.forEach((item) => {
        if (!item.autocomplete && item.listParam) {
          let shouldBeDone = (item.listParam === this.define.name);
          if (Array.isArray(item.listParam)) {
            shouldBeDone = item.listParam.includes(this.define.name);
          }
          if (shouldBeDone) {
            // Load lại list
            const key = this.getListOptionsKey(item);
            if (!this.form.optionsMap[key]) {
              this.getListValues(item, null, null, result => {
                if (item.tree) {
                  // alert('Dont support tree list with param ' + item.caption);
                  this.form.optionsMap[key] = result;
                } else {
                  this.form.optionsMap[key] = Util.toKendoListValues(result);
                }

                // Nếu không có data thì cho nó null luôn.
                const index = result.findIndex(rec => rec[0] === this.record[item.name]);
                if (index < 0) {
                  const complexName = Util.complexFieldName(item.name);
                  this.record[item.name] = null;
                  this.record[complexName] = null;
                }
              });
            }else{
              // Nếu không có data thì cho nó null luôn.
              const index = this.form.optionsMap[key].findIndex(rec => rec[0] === this.record[item.name]);
              if (index < 0) {
                const complexName = Util.complexFieldName(item.name);
                this.record[item.name] = null;
                this.record[complexName] = null;
              }
            }
          }
        }
      });
    }

    // Update text value
    let listItem: any = null;
    if (text) {
      const complexName = Util.complexFieldName(this.define.name);
      this.record[complexName] = {value, text};
    }else if (value !== undefined){
      let list = null;
      if (this.define.listValues) {
        list = this.define.listKendoValues;
      }else if (this.define.listName && !this.define.autocomplete) {
        list = this.form.optionsMap[this.define.listName];
      }
      if (list) {
        const index = list.findIndex(rec => rec.value === value);
        listItem = list[index];
        const complexName = Util.complexFieldName(this.define.name);
        if (index > -1) {
          this.record[complexName] = {value, text: list[index].text};
        } else {
          console.log('Update complex but not found');
          console.log(list);
          console.log(value);
        }
      }
    }


    if (this.changed) {
      this.changed.emit({value, listItem});
    }
  }

  download(): void {
    const id = this.record.id;
    const field = this.define.name;
    if (id && this.apiUrl) {
      // let thumbnail = 0;
      // if (this.define.imange)
      this.api.getBinary(this.apiUrl, id, field, (code, message) => {
        if (code !== ServiceCode.Success) {
          alert(message);
        }
      });
    }
  }

  loadImage(): void {
    if (this.define && this.define.image && this.record && this.apiUrl) {
      // console.error('Load image ' + this.define.name + this.record.id);
      let id = this.record.id;
      if (this.define.imageParams) {
        const paramNames = this.define.imageParams.split(',');
        const params = [];
        paramNames.forEach(item => {
          if (this.record[item]){
            params.push(this.record[item]);
          }
        });
        if (params.length > 0) {
          id = params.join(',');
        }
      }
      if (!id) {
        return;
      }
      this.image = null;
      const field = this.define.name;
      if (this.record[field] || this.define.imageParams) {
        // let thumbnail = 0;
        // if (this.define.imange)
        this.api.getImage(this.apiUrl, id, field, this.thumbnail, (code, message, image) => {
          if (code === ServiceCode.Success) {
            this.image = image;
          // }else {
          //   console.error(field + '=' + id);
          }
        });
      }
    }
  }

  navigate(): void {
    let links = this.link(this.record);
    if (!links) {
      return;
    }

    if (!Array.isArray(links)) {
      links = [links];
    }

    let params = null;
    if (links.length > 1) {
      params = links[1];
    }
    this.state.navigate(links[0], this.form, params);
  }

  deleteFile(): void {
    const fileFieldName = Util.fileFieldName(this.define.name);
    this.record[fileFieldName] = '__delete__';
    this.record[this.define.name] = null;
  }

  onFileChange(event): void {

    const fileFieldName = Util.fileFieldName(this.define.name);
    if (event.target.files && event.target.files.length) {
      this.record[fileFieldName] = event.target.files[0];
    } else {
      delete this.record[fileFieldName];
    }


    // const reader = new FileReader();
    //
    // if (event.target.files && event.target.files.length) {
    //   const [file] = event.target.files;
    //   alert(event.target.files[0].name);
    //   reader.readAsDataURL(file);
    //
    //   reader.onload = () => {
    //     this.record[this.define.name] = reader.result;
    //   };
    // }
  }

  /**
   * Return null if does not have list param
   * If list param is array, return the array of param's values.
   * If param value is null, replaced by -1
   * @param define
   * @param value
   * @private
   */
  private getListOptionsParams(define: FieldDefine, value = null): any {
    if (define.listParam) {
      if (Array.isArray(define.listParam)){
        const param = [];
        define.listParam.forEach(item => {
          if (item === this.define.name && value != null) {
            param.push(value);
          }else{
            if (this.record[item]){
              param.push(this.record[item]);
            }else{
              // -1 so that it search nothing
              param.push(-1);
            }
          }

        });
        return param;
      }else{
        return value != null ?
              value : this.record[define.listParam] == null || this.record[define.listParam] === '' ?
              -1 : this.record[define.listParam];
      }
    }
    return null;
  }

  private getListOptionsKey(define: FieldDefine, value: string = null): string {
    let key = define.listName;
    const param = this.getListOptionsParams(define, value);
    if (param){
      if (Array.isArray(param)){
        key = key + param.join('-');
      }else{
          key = key + param;
      }
    }

    return key;
  }

  text(): string {
    const complexName = Util.complexFieldName(this.define.name);
    if (this.record[complexName]) {
      return this.record[complexName].text;
    }
    return this.value;
  }

  // listValue(): string {
  //   const text = this.text();
  //   if (text) {
  //     return  text;
  //   }
  //   // const index = this.define.listValues.findIndex(item => item[0] === this.value);
  //   // if (index >= 0) {
  //   //   return this.define.listValues[index][1];
  //   // }
  //   return '';
  // }
  //
  // autoCompleteValue(): string {
  //   const text = this.text();
  //   if (text) {
  //     return  text;
  //   }
  //   return '';
  //   // if (!this.form.optionsMap) {
  //   //   return '';
  //   // }
  //   // const key = this.getListOptionsKey(this.define);
  //   // if (!this.form.optionsMap[key]) {
  //   //   return '';
  //   // }
  //   //
  //   // const index = this.form.optionsMap[key].findIndex(item => item.value === this.value);
  //   // if (index >= 0) {
  //   //   return this.form.optionsMap[key][index].text;
  //   // }
  //   // return '';
  // }

  onAutocompleteInput(event: Event): void {
    if (this.isLoading) {
      return;
    }
    const value = (event.target as HTMLInputElement).value;
    if (value) {
      if (this.autocompleteTextExist(value)) {
        return;
      }
    }
    this.isLoading = true;
    this.getListValues(this.define, value, null, (result => {
      this.isLoading = false;
      this.autocompleteOptions = [];
      if (result) {
        result.forEach(item => {
          this.autocompleteOptions.push(item[1]);
        });
        this.autocompleteData = this.autocompleteOptions.slice();
      }
    }));
  }

  onListInput(event: Event = null): void {
    if (this.isLoading) {
      return;
    }

    // Get from optionMap first.
    const key = this.getListOptionsKey(this.define);
    this.optionsKey = key;
    if (this.form.optionsMap[key] && this.form.optionsMap[key].length > 0){
      this.data = this.form.optionsMap[key].slice();
      return;
    }

    let value = null;
    if (event) {
      value = (event.target as HTMLInputElement).value;
    }

    if (value) {
      if (this.listTextExist(value)) {
        return;
      }
    }

    // Load from server
    this.isLoading = true;
    this.getListValues(this.define, value, null, (result => {
      this.isLoading = false;
      if (result) {
        if (this.define.tree) {
          this.form.optionsMap[key] = result;
        }else{
          this.form.optionsMap[key] = Util.toKendoListValues(result);
          this.data = this.form.optionsMap[key].slice();
        }

        // TODO: Có cần thiết add cái giá trị hiện có này không? Tạm thời comment lại đi
        // const complexName = Util.complexFieldName(this.define.name);
        // if (this.record[complexName]){
        //   const index = this.listOptions.findIndex(item => item.value === this.record[complexName].value);
        //   if (index < 0) {
        //     this.listOptions.push(this.record[complexName]);
        //   }
        // }

      }
    }));
  }

  private listTextExist(value): boolean {
    if (this.form.optionsMap[this.define.listName]) {
      const index = this.form.optionsMap[this.define.listName].findIndex(rec =>
      {
        if (!rec.text) {
          return false;
        }
        return rec.text.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      });
      return index > -1;
    }
    return false;
  }

  private autocompleteTextExist(value): boolean {
    if (this.autocompleteOptions) {
      const index = this.autocompleteOptions.findIndex(rec => rec.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      return index > -1;
    }
    return false;
  }

  private getListValues(define: FieldDefine, value: string, max: number , OnCompleted: (result: any []) => void): void {
    const param = this.getListOptionsParams(define);
    this.api.getListValues(define.listName, param, value, max, (result) => {
      OnCompleted(result);
    });
  }

  handleFilter(value): void {
    const key = this.getListOptionsKey(this.define);
    if (this.form.optionsMap[key]) {
      this.data = this.form.optionsMap[key].filter((rec) => {
        if (!rec.text) {
          return false;
        }
        let ret = rec.text.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        if (!ret && rec.extra1) {
          ret = rec.extra1.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        }
        return ret;
      });
    }
  }

  handleAutocompleteFilter(value): void {
    this.autocompleteData = this.autocompleteOptions.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    if (this.autocompleteData.length < 1) {
      this.autocompleteData = this.autocompleteOptions.slice();
    }
  }
}
